import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useSelectedCollectionTitleFieldId (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('selectedCollectionTitleFieldId', callback),
    () => state.selectedTitleFieldId
  )
}
